<div class="dvb-stunden-kontingent-title">
    <span data-translate="COMMON.GUELTIGKEIT_VON_BIS"
          data-translate-value-date-ab="{{vm.stundenKontingent.gueltigAb | amDateFormat:'D.M.YYYY'}}"
          data-translate-value-date-bis="{{vm.stundenKontingent.gueltigBis | amDateFormat:'D.M.YYYY'}}">
    </span>
</div>
